import React from "react";
import { TextBox } from "../text-box";
import { useUI } from "../../context";
import { Button } from "../../ui/button";

export const Step5 = (props) => {
  const {
    page_settings: { confirm },
  } = useUI();

  return (
    <>
      <div className="flex gap-6 max-lg:flex-col-reverse">
        <img
          className="lg:max-w-[300px] w-full object-cover self-start"
          src={confirm.image}
          alt=""
        />
        <div className="max-w-[300px] flex flex-col gap-[50px]">
          <TextBox title={confirm.title} description={confirm.description} />
          <a href={confirm.button.url} className="max-lg:hidden">
            <Button>{confirm.button.title}</Button>
          </a>
        </div>
      </div>
    </>
  );
};
